var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-6 py-5"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_c('master-production-list')],1),_c('div',{staticClass:"column is-half"},[_c('workstation-queues')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }